import FluxUtils from 'flux/utils';
import Immutable from 'immutable';
import React from 'react';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import StackedDialogStore from 'sharedreact/stores/StackedDialogStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import IdentityProvidersActions from 'workspaces/launcher/actions/IdentityProvidersActions';
import OpenIDConfigActions from 'workspaces/launcher/actions/OpenIDConfigActions';
import IdentityProvidersTab from 'workspaces/launcher/components/admin/IdentityProvidersTab';
import IdentityProviders from 'workspaces/launcher/data/IdentityProviders';
import LdapConfig from 'workspaces/launcher/data/LdapConfig';
import IdentityProvidersStore from 'workspaces/launcher/stores/IdentityProvidersStore';
import OpenIDConfigsStore from 'workspaces/launcher/stores/OpenIDConfigsStore';

type Props = {
  index: number,
  activeTab: number
};

type State = ConstructorParameters<typeof IdentityProvidersTab>[0];

function getStores () {
  return [
    SettingsStore,
    IdentityProvidersStore,
    OpenIDConfigsStore,
    StackedDialogStore
  ];
}

function handleRemoveOpenIDConfig (id: string): void {
  OpenIDConfigActions.remove(Immutable.Set([id]));
}

function handleSaveLdapConfig (identityProviders: IdentityProviders, ldapConfig: LdapConfig): void {
  IdentityProvidersActions.save(identityProviders.set('ldapConfig', ldapConfig));
}

function handleLoad (): void {
  IdentityProvidersActions.fetch();
  OpenIDConfigActions.fetch();
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  const identityProviders: IdentityProviders = IdentityProvidersStore.getItem();

  return {
    language: SettingsStore.getLanguage(),
    identityProviders: identityProviders,
    index: props.index,
    activeTab: props.activeTab,
    openIDConfigs: OpenIDConfigsStore.getItems(),
    onSaveIdentityProviders: IdentityProvidersActions.save,
    onSaveOpenIDConfig: OpenIDConfigActions.save,
    onSaveLdapConfig: (ldapConfig) => handleSaveLdapConfig(identityProviders, ldapConfig),
    onRemoveOpenIDConfig: handleRemoveOpenIDConfig,
    onLoad: handleLoad
  };
}

export default FluxUtils.Container.createFunctional(
  React.createFactory(IdentityProvidersTab),
  getStores,
  calculateState,
  { withProps: true }
);
